import React, { useState } from "react";
import { Modal, Divider, Form } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { Button, InputAdornment, OutlinedInput } from "@material-ui/core";
import DynamicAddExpense from "./dynamic-add-expense";
import { PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { useCountry, useCurrency } from "../../provider/courtryProvider";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    "& legend": {
      display: "none",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
}));

const SummaryModal = ({
  open,
  setOpen,
  counterSales,
  endCounter,
  setCounterSales,
}) => {
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const classes = useStyles();
  const [form] = Form.useForm();
  const [notes, setNotes] = useState({
    show: false,
    data: "",
  });

  const handleClose = () => {
    form.resetFields();
    setOpen(false);
  };

  const [availableCash, setAvailableCash] = useState("");
  const [cashHandover, setCashHandover] = useState("");
  const [closingBalance, setClosingBalance] = useState("");

  const handleSubmit = (values) => {
    if (notes.show && !notes.data) {
      return alert("Please enter the notes");
    }
    console.log("values", values);
    endCounter(
      availableCash,
      cashHandover,
      closingBalance,
      counterSales.totalCashReceived,
      counterSales.cashBalancePaid,
      counterSales.totalCashSale,
      counterSales.totalUpiSale,
      counterSales.totalCreditSale,
      counterSales.totalCardSale,
      counterSales.totalSales,
      counterSales.totalExpenses + counterSales.totalNewExpense,
      values.expenses,
      notes
    );
  };
  return (
    <>
      <Modal
        open={open}
        closable={false}
        footer={false}
        centered
        className={classes.modalStyle}
        width={700}
      >
        <div
          style={{
            paddingRight: "1rem",
          }}
        >
          <h3
            style={{
              color: "#EF4667",
            }}
          >
            Today’s Counter Summary
          </h3>
          <Divider className={classes.dividerStyle} />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "2rem",
            }}
          >
            <div>Start of Counter</div>
            <div>{counterSales.openTime}</div>
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Opening Cash Balance</div>
            <div>{currencyFormatter(counterSales.openBalance)}</div>
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Total Upi Sales</div>
            <div>{currencyFormatter(counterSales.totalUpiSale)}</div>
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Total Card Sales</div>
            <div>{currencyFormatter(counterSales.totalCardSale)}</div>
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Total Credit Sales</div>
            <div>{currencyFormatter(counterSales.totalCreditSale)}</div>
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Total Cash Sales</div>
            <div>{currencyFormatter(counterSales.totalCashSale)}</div>
          </div>
          <Divider className={classes.dividerStyle} />
          <DynamicAddExpense
            setCounterSales={setCounterSales}
            form={form}
            handleSubmit={handleSubmit}
          />
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Total Expenses</div>
            <div>
              {currencyFormatter(
                counterSales.totalExpenses + counterSales.totalNewExpense
              )}
            </div>
          </div>
          <Divider className={classes.dividerStyle} />
          {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>Cash Expense</div>
          <div>0.00</div>
        </div> */}
          {/* <Divider className={classes.dividerStyle} /> */}
          {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>Paid Amount</div>
          <div>24,000.00</div>
        </div>
        <Divider className={classes.dividerStyle} /> */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Total Cash available in the Counter</div>
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">{}</InputAdornment>
              }
              type="number"
              value={
                parseFloat(counterSales.totalCashSale) -
                parseFloat(counterSales.totalExpenses) -
                parseFloat(counterSales.totalNewExpense || 0) +
                parseFloat(counterSales.openBalance || 0)
              }
              disabled
              style={{
                cursor: "not-allowed",
              }}
            />
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Cash Handover</div>
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  {country.CurrencySymbol}
                </InputAdornment>
              }
              type="number"
              value={cashHandover}
              onChange={(e) => setCashHandover(e.target.value)}
            />
          </div>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>Counter Closing Balance</div>
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  {country.CurrencySymbol}
                </InputAdornment>
              }
              type="number"
              value={
                counterSales.totalSales -
                counterSales.totalExpenses -
                counterSales.totalNewExpense
              }
              disabled
            />
          </div>
          <Divider className={classes.dividerStyle} />
          <div>
            <Button
              onClick={() => {
                setNotes((prev) => ({
                  ...prev,
                  show: true,
                }));
              }}
              variant="text"
            >
              <PlusOutlined />
              {"  "} <span style={{ marginLeft: "4px" }}> Notes</span>
            </Button>
            {notes.show && (
              <TextArea
                placeholder="Leave some note here..."
                style={{
                  borderRadius: "0.5rem",
                }}
                onChange={(v) =>
                  setNotes((prev) => ({
                    ...prev,
                    data: v.target.value,
                  }))
                }
              />
            )}
          </div>
          <div
            style={{
              textAlign: "right",
              marginTop: "2rem",
            }}
          >
            <Button
              style={{
                border: "1px solid #E60F00",
                width: "200px",
              }}
              size="large"
              onClick={handleClose}
            >
              CONTINUE SALES
            </Button>
            <Button
              style={{
                background: "#E60F00",
                width: "200px",
                marginLeft: "16px",
                color: "#fff",
              }}
              size="large"
              onClick={() => {
                form.submit();
              }}
            >
              END COUNTER
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SummaryModal;
